import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import PostComposer from "./PostComposer";
import SocialFeed from "./SocialFeed";

const CampaignSocial = ({ campaign, organization }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { user: currentUser } = useAuth();

  const handlePostCreated = () => {
    setRefreshTrigger((prev) => prev + 1);
    toast.success("Your post has been shared with the community!");
  };

  const campaignId = campaign?._id;

  if (!campaignId) {
    return (
      <div className="text-center py-8">
        <p className="text-jacarta-500 dark:text-jacarta-400">
          Campaign information is not available.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-jacarta-50 dark:bg-jacarta-900">
      <div className="px-6 py-6">
        <h2 className="text-2xl font-bold text-jacarta-700 dark:text-white text-center mb-6">
          Words of Support
        </h2>
        <div className="max-w-2xl mx-auto">
          <PostComposer
            campaignId={campaignId}
            onPostCreated={handlePostCreated}
            currentUser={currentUser}
          />
          <SocialFeed
            campaignId={campaignId}
            currentUser={currentUser}
            refreshTrigger={refreshTrigger}
          />
        </div>
      </div>
    </div>
  );
};

export default CampaignSocial;
